// Dados do responsável pelo site (aparecem no rodapé e nas políticas). O que ficar vazio não é exibido.
export const LEGAL_ENTITY = {
  nome: "PKXIdle · Arcade Azulo",   // nome do projeto e do responsável
  documento: "",                    // CNPJ ou CPF (não divulgado)
  email: "dawialencar22@yahoo.com", // e-mail de contato / privacidade
  endereco: "",                     // cidade/UF ou endereço (não divulgado)
};
